const ScheduleType = {
  REPEATING: 0,
  SINGLE_SHIFT: 1,
};

module.exports = {
  ScheduleType,
};
